import React from 'react';
import PropTypes from 'prop-types';
import capitalize from '../../../stringUtils';
import './ProposalStatusPill.scss';
function ProposalStatusPill(_ref) {
  var status = _ref.status;
  if (!status) return null;
  return /*#__PURE__*/React.createElement("span", {
    className: "proposal-status ".concat(status)
  }, capitalize(status));
}
ProposalStatusPill.propTypes = {
  status: PropTypes.string
};
ProposalStatusPill.defaultProps = {
  status: null
};
export default ProposalStatusPill;